import type { Breakpoint, StackProps } from '@mui/material';
import { Stack, useMediaQuery, useTheme } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';

import { industriesWeServeData } from './IndustriesWeServe.data';
import type { IndustryData } from './IndustriesWeServe.types';
import {
  StyledStack,
  StyledFirstTitle,
  StyledServiceItem,
  StyledServiceIcon,
  StyledServiceIconWrapper,
  StyledServiceIconBackground,
  StyledServiceTitle,
  StyledServiceDescription,
} from './styles';

const ServiceElement = ({ img, title, description }: IndustryData) => (
  <StyledServiceItem>
    <StyledServiceIconWrapper>
      <StyledServiceIconBackground>
        <StyledServiceIcon src={img} alt={title} />
      </StyledServiceIconBackground>
    </StyledServiceIconWrapper>

    <StyledServiceTitle variant="strong_400">{title}</StyledServiceTitle>

    <StyledServiceDescription variant="regular_300">
      {description}
    </StyledServiceDescription>
  </StyledServiceItem>
);

const ServicesDesktopLayout = () => {
  return (
    <Stack alignItems="center" gap={4}>
      <ServiceElement {...industriesWeServeData[0]} />

      <Stack
        direction="row"
        justifyContent="space-between"
        width="100%"
        gap={4}
        alignItems="center">
        <ServiceElement {...industriesWeServeData[1]} />
        <StyledFirstTitle variant="display_sm">
          Industries We Serve
        </StyledFirstTitle>
        <ServiceElement {...industriesWeServeData[2]} />
      </Stack>

      <Stack direction="row" justifyContent="space-between" gap={4}>
        <ServiceElement {...industriesWeServeData[3]} />
        <ServiceElement {...industriesWeServeData[4]} />
      </Stack>
    </Stack>
  );
};

const ServicesMobileLayout = () => {
  return (
    <Stack alignItems="center" gap={3}>
      <StyledFirstTitle variant="display_sm">
        Industries We Serve
      </StyledFirstTitle>

      {industriesWeServeData.map((data, index) => (
        <ServiceElement key={index} {...data} />
      ))}
    </Stack>
  );
};

export const IndustriesWeServe = ({ ...props }: StackProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md' as Breakpoint));

  return (
    <Section width="normal">
      <StyledStack {...props}>
        {isMobile ? <ServicesMobileLayout /> : <ServicesDesktopLayout />}
      </StyledStack>
    </Section>
  );
};
